import React from "react";
import styled from "styled-components";

const HeaderIconWrapper = styled.div`
  width: 80px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #cccaca;
`;

const Count = styled.div`
  position: absolute;
  width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Lato;
  font-size: 12px;
  height: 18px;
  background-color: black;
  color: white;
  border-radius: 50%;
  margin-top: -12px;
  margin-left: 15px;
`;

function HeaderIcon({ Icon, count }: IHeaderIcon) {
  return (
    <HeaderIconWrapper>
      {Icon}
      {count > 0 && <Count>{count}</Count>}
    </HeaderIconWrapper>
  );
}

export interface IHeaderIcon {
  Icon: any;
  count: number;
}

export default HeaderIcon;
